// This is an autogenerated file, please do not modify this file manually.
// All exported modules have to be made available via the /lib folder.
// In case you added a new file to the /lib folder, pleas rerun the scripts/create-library-export.js script.

import eureka from './src/eureka';
export default eureka;